import React, { useEffect, useContext, useState, useRef, useCallback } from "react";
import PropertyDetailWithImage from "../PropertyDetailWithImage";
import { getAllProperties, getSearchResultsWithPagination } from "services";
import { Context, getSortOptions, payloadToUrl } from "services";
import Footer from "../../layouts/footer/Footer";
import { useRouter } from "next/router";
import { ChevronDownIcon, FilterIcon, XIcon } from "@heroicons/react/solid";
import { DropdownMultiHover, TwoColumnSectionBase } from "@reusejs/react";
import PlaceholderComponent from "./PlaceholderComponent";
import PlaceHolderContent from "./PlaceHolderContent";
import { SideBarSearch } from "app";
import { getSearchPayload } from "services";
import {
  TrendingPropertiesComponent,
  ConsultationComponent,
  RecentlyVisitedComponent,
} from "app";
import { Dialog, Transition } from "@headlessui/react";
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { useView } from "./context/ViewContext";
import PropertyListView from "./PropertyListView";
import { ClearFiltersBadge } from "./FilterComponent";
export function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}
export const formatDate = (dateString: any) => {
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }

  return `${date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  })} `;
};
export const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;
// export const AnimatedDiv = styled.div<{ theme?: any }>`
//   background: linear-gradient(to right, #f0f0f0 8%, #e0e0e0 18%, #f0f0f0 33%);
//   background-size: 1000px 100%;
//   animation: ${shimmer} 1.5s linear infinite;
// `;
export const CardSkeleton = () => (
  <div className="flex flex-col items-center space-y-4 mr-4 ">
    <div className="w-62 sm:w-[256px] h-40 rounded"></div>
    <div className="w-60 h-4 rounded"></div>
    <div className="w-48 h-4 rounded"></div>
  </div>
);
export default function PropertiesComponent() {
  // State declarations
  const { searchForm }: any = useContext(Context);
  const router = useRouter();
  const [allPropertiesData, setAllPropertiesData] = useState<any>([]);
  const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);
  const [noMoreData, setNoMoreData] = useState(false);
  const [filterSearchResult, setFilterSearchResult] = useState<any>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogFilterData, setDialogFilterData] = useState<any>(null);
  const { currentView, page, setPage } = useView();
  const [isLoading, setIsLoading] = useState(false);
  const [listingIds, setListingIds] = useState([]);

  // Function to deduplicate properties based on UUID
  // const deduplicateProperties = (properties: any[]) => {
  //   const seen = new Set();
  //   return properties.filter(item => {
  //     const duplicate = seen.has(item.uuid);
  //     seen.add(item.uuid);
  //     return !duplicate;
  //   });
  // };

  // Debug logging for data mismatch
  // useEffect(() => {
  //   console.log("Total reported: ========", searchForm.value.total);
  //   console.log("Actual visible cards: ========", allPropertiesData.length);
  //   console.log("Match: ==========", searchForm.value.total === allPropertiesData.length);
  // }, [allPropertiesData, searchForm.value.total]);

  // Function to clear all filters
  const handleClearFilters = () => {
    // Reset all filter fields
    searchForm.setField("asset_type", "");
    searchForm.setField("sub_asset_type", "");
    searchForm.setField("state", "");
    searchForm.setField("city", "");
    searchForm.setField("reserve_price", "");
    searchForm.setField("institutes", "");
    searchForm.setField("filter_by",{
      label: "scheduled",
      value: "dated",
    });
    searchForm.setField("sort_by", "");
    searchForm.setField("auction_start_date_unix_timestamp", "");
    setPage(1);
    payloadToUrl(router, searchForm.value);
  };

  // Check if any filters are applied
  const hasFiltersApplied = () => {
    return (
      searchForm.value.asset_type ||
      searchForm.value.sub_asset_type ||
      searchForm.value.state ||
      searchForm.value.city ||
      searchForm.value.reserve_price ||
      searchForm.value.institutes ||
      searchForm.value.filter_by.value === "private_treaty" || 
      searchForm.value.filter_by.value === "undated" || 
      searchForm.value.auction_start_date_unix_timestamp
    );
  };

  // Fetch filter data
  const fetchFilterData = useCallback(async () => {
    try {
      const typesensePayload = getSearchPayload(searchForm, router, page);
      // console.log('Typesense payload:', typesensePayload);
      const response: any = await getSearchResultsWithPagination({
        searches: typesensePayload,
      }, 48, page);
      // console.log('Dialog filter data:', response);
      setDialogFilterData(response);
    } catch (error) {
      console.error('Error fetching filter data:', error);
    }
  }, [searchForm, router, page]);

  // Open dialog and fetch initial data
  const openDialog = useCallback(async () => {
    setIsLoading(true);
    try {
      const typesensePayload = getSearchPayload(searchForm, router, 1);
      // console.log('Typesense payload:', typesensePayload);
      const response: any = await getSearchResultsWithPagination({
        searches: typesensePayload,
      },48, page);
      
      // console.log('Dialog filter data:', response);
      setDialogFilterData(response);
      setIsDialogOpen(true);
    } catch (error) {
      console.error('Error fetching filter data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [searchForm, router]);

  // Toggle dialog open/close
  const toggleDialog = useCallback(() => {
    if (isDialogOpen) {
      setIsDialogOpen(false);
    } else {
      openDialog();
    }
  }, [isDialogOpen, openDialog]);

  // Debug logging for filter search results
  useEffect(() => {
    // console.log('filterSearchResult updated:', filterSearchResult);
  }, [filterSearchResult]);

  // Debug logging for dialog state and data
  // useEffect(() => {
  //   // console.log('Dialog open state:', isDialogOpen);
  //   if (isDialogOpen) {
  //     console.log('Current dialogFilterData:', dialogFilterData);
  //   }
  // }, [isDialogOpen, dialogFilterData]);

  // Fetch filter data when dialog is open or filters change
  useEffect(() => {
    if (isDialogOpen) {
      fetchFilterData();
    }
  }, [
    isDialogOpen,
    searchForm.value.asset_type.value,
    searchForm.value.sub_asset_type.value,
    searchForm.value.state.value,
    searchForm.value.institutes.value,
    searchForm.value.city.value,
    searchForm.value.reserve_price,
    searchForm.value.auction_start_date_unix_timestamp,
    searchForm.value.filter_by.value,
    searchForm.value.sort_by.value,
  ]);

  // Main function to fetch and update search results
  const fetchSearchResults = async (pageToFetch: number) => {
    setIsFetchingNextPage(true);

    const typesensePayload = getSearchPayload(searchForm, router, pageToFetch);
    // console.log("typesense payload ==> ", typesensePayload)
    
    try {
      const response: any = await getSearchResultsWithPagination({
        searches: typesensePayload,
      }, 48, pageToFetch);
       
      // console.log("response , ", response)
      // const newListingIds = response.results[0].hits.map(el => el.document.listing_id);
      // setListingIds(prevIds => [...prevIds, ...newListingIds]);
      
      setFilterSearchResult(response);
      const searchResults = response?.results[0]?.hits?.map(
        (value: any) => value.document
      );

      // console.log("search results ", searchResults)
      searchForm.setField("total", response?.results[0]?.found);
      // console.log("hits ======>>>> ", response?.results[0]?.hits?.length)

      if (searchResults && searchResults.length > 0) {
        const previousScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        setAllPropertiesData((prevData: any) => [...prevData, ...searchResults]);
        setPage(pageToFetch);
        setIsFetchingNextPage(false);

        setTimeout(() => {
          window.scrollTo(0, previousScrollTop);
        }, 0);
      } else {
        setIsFetchingNextPage(false);
        setNoMoreData(true);
      }
    } catch (error) {
      console.error('Error fetching search results:', error);
      setIsFetchingNextPage(false);
    }
  };

  // Effect to fetch initial data and update URL
  useEffect(() => {
    // console.log("all properties data before setAllPropertiesData =========> ", allPropertiesData)
    setAllPropertiesData([]);
    setPage(1);
    setNoMoreData(false);
    fetchSearchResults(1);
    payloadToUrl(router, searchForm.value);
  }, [
    searchForm.value.asset_type.value,
    searchForm.value.sub_asset_type.value,
    searchForm.value.state.value,
    searchForm.value.institutes.value,
    searchForm.value.city.value,
    searchForm.value.reserve_price,
    searchForm.value.auction_start_date_unix_timestamp,
    searchForm.value.filter_by.value,
    searchForm.value.sort_by.value,
  ]);

  // Debounce function to limit frequency of function calls
  const debounce = (func: any, delay: number): any => {
    let timeoutId: any;
    return (...args: any[]): void => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  // Effect to handle infinite scrolling
  useEffect(() => {
    if (currentView === 'grid') {
      const handleScroll = debounce(() => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        const clientHeight = document.documentElement.clientHeight || window.innerHeight;
        const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight - 200;

        if (scrolledToBottom) {
          loadMoreData();
        }
      }, 300);

      window.addEventListener('scroll', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [currentView, page, isFetchingNextPage, noMoreData]);

  // Sort dropdown component
  const SortDropdown = () => (
    <DropdownMultiHover
      dropdownMultiHoverClasses={{
        containerClasses:
          'absolute z-20 left-0 w-56 origin-top-left border dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none rounded-md',
      }}
      label={() => (
        <span className="relative -mb-px flex items-center border-b-2 border-transparent pt-px text-sm font-semibold text-gray-700 transition-colors duration-200 ease-out hover:text-blue-600">
          Sort by
          <ChevronDownIcon height="20" width="20" className="ml-1" />
        </span>
      )}
      items={getSortOptions()}
      onClick={(item, index) => {
        if (item.value === "all_properties") {
          searchForm.setField("sort_by", {
            label: item.label,
            value: item.value,
          });
          searchForm.setField("asset_type", "");
          searchForm.setField("sub_asset_type", "");
          searchForm.setField("state", "");
          searchForm.setField("city", "");
          searchForm.setField("reserve_price", "");
          searchForm.setField("institutes", "");
          searchForm.setField("filter_by", "");
          payloadToUrl(router, searchForm.value);
        } else {
          searchForm.setField("sort_by", {
            label: item.label,
            value: item.value,
          });
          searchForm.setField("asset_type", "state");
          payloadToUrl(router, searchForm.value);
        }
      }}
    />
  );

  const loadMoreData = () => {
    if (!isFetchingNextPage && !noMoreData) {
      fetchSearchResults(page + 1);
    }
  };


  // console.log("all properties data ====== ", allPropertiesData)
  // console.log("response array , ", listingIds)

  return (
    <>
      <div className="bg-white relative bg-gray-50 rounded-md ">
        <div className="max-w-[100vw] flex justify-center mx-auto ">
          <div className="flex flex-col md:flex-row md:gap-x-4 flex-1">
            <div className="hidden sm:block md:pt-2 md:h-[calc(100vh-95px)] w-[100vw] md:w-[270px] lg:w-[310px] xl:w-[320px] md:sticky top-[110px] items-start">
              <SideBarSearch
                filterSearchResult={filterSearchResult}
                propertyType={true}
              />
            </div>

            {allPropertiesData.length === 0 && !isFetchingNextPage ? (
              <div className="w-full h-full flex flex-col">
              <div className="sm:hidden">
              <div className="flex items-center sm:hidden justify-between pt-4 px-6">
                <div className="flex items-center gap-x-2">
                    <DropdownMultiHover
                      dropdownMultiHoverClasses={{
                        containerClasses:
                          "absolute z-20 left-0 w-56 origin-top-left border dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  rounded-md",
                      }}
                      label={() => (
                        <span className="relative -mb-px flex items-center border-b-2 border-transparent pt-px text-sm font-semibold text-gray-700 transition-colors duration-200 ease-out hover:text-blue-600">
                          Sort by
                          <ChevronDownIcon
                            height="20"
                            width="20"
                            className="ml-1"
                          />
                        </span>
                      )}
                      items={getSortOptions()}
                      onClick={(item, index) => {
                        if (item.value === "all_properties") {
                          searchForm.setField("sort_by", {
                            label: item.label,
                            value: item.value,
                          });
                          searchForm.setField("asset_type", "");
                          searchForm.setField("sub_asset_type", "");
                          searchForm.setField("state", "");
                          searchForm.setField("city", "");
                          searchForm.setField("reserve_price", "");
                          searchForm.setField("institutes", "");
                          searchForm.setField("filter_by", "");
                          payloadToUrl(router, searchForm.value);
                        } else {
                          searchForm.setField("sort_by", {
                            label: item.label,
                            value: item.value,
                          });
                          searchForm.setField("asset_type", "state");
                          payloadToUrl(router, searchForm.value);
                        }
                      }}
                    />
                    {hasFiltersApplied() && <ClearFiltersBadge onClick={handleClearFilters} />}
                    </div>
                    <FilterIcon
                      className="h-5 mr-2 text-gray-600 cursor-pointer"
                      onClick={toggleDialog}
                    />
                  </div>
              </div>
              <div className="w-full h-[70vh] font-bold text-[30px] flex items-center justify-center">
                No Search Result Found!
              </div>
              </div>
            ) : (
              <div className="sm:pt-20 w-full grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 4k:grid-cols-6 gap-y-6 gap-x-4 sm:gap-x-6 sm:auto-rows-fr">
                {useRouter().pathname !== "/" && (
                  
                  <div className="flex items-center justify-between px-8 py-3 bg-white shadow-sm sm:hidden">
                    <div className="flex items-center gap-x-2">
                    <DropdownMultiHover
                    dropdownMultiHoverClasses={{
                      containerClasses:
                        "absolute z-20 left-0 w-56 origin-top-left border dark:border-gray-800 bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none rounded-md",
                    }}
                    label={() => (
                      <span className="relative flex items-center text-sm font-medium text-gray-700 transition-colors duration-200 ease-out hover:text-blue-600">
                        Sort by
                        <ChevronDownIcon height="18" width="18" className="ml-1" />
                      </span>
                    )}
                    items={getSortOptions()}
                    onClick={(item, index) => {
                      if (item.value === "all_properties") {
                        searchForm.setField("sort_by", {
                          label: item.label,
                          value: item.value,
                        });
                        searchForm.setField("asset_type", "");
                        searchForm.setField("sub_asset_type", "");
                        searchForm.setField("state", "");
                        searchForm.setField("city", "");
                        searchForm.setField("reserve_price", "");
                        searchForm.setField("institutes", "");
                        searchForm.setField("filter_by", "");
                        payloadToUrl(router, searchForm.value);
                      } else {
                        searchForm.setField("sort_by", {
                          label: item.label,
                          value: item.value,
                        });
                        searchForm.setField("asset_type", "state");
                        payloadToUrl(router, searchForm.value);
                      }
                    }}
                  />
                    {hasFiltersApplied() && <ClearFiltersBadge onClick={handleClearFilters} />}
                    </div>
                  
                  
                  <FilterIcon
                    className="h-5 text-gray-600 cursor-pointer"
                    onClick={toggleDialog}
                  />
                </div>
                )}


{currentView === 'grid' ? (
                  <>
                  {allPropertiesData.map((item: any, index: any) => (
                      <div className="flex flex-col items-center" key={item.uuid}>
                        <PropertyDetailWithImage
                          top={true}
                          widthClass="w-64"
                          width={256}
                          height={160}
                          onClick={() => console.log("Card action button clicked")}
                          property={item}
                          {...item}
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <div className="col-span-1 sm:col-span-2 lg:col-span-3 xl:col-span-4 2xl:col-span-5 -mt-6 -mx-4">
                     <PropertyListView
            filterSearchResult={filterSearchResult}
            isLoading={isFetchingNextPage}
            propertiesData={allPropertiesData}
            onLoadMore={loadMoreData}
          />
                  </div>
                )}

{isFetchingNextPage && 
  currentView === 'grid' && (
    <>
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
    </>
  ) }
              </div>
            )}
          </div>
        </div>
      </div>

      <Transition appear show={isDialogOpen} as={React.Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={() => setIsDialogOpen(false)}
        >
          <div className="min-h-screen text-center">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30 transition-opacity" />
            </Transition.Child>

            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-full"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-full"
            >
              <div className="fixed inset-x-0 bottom-0 w-full transform transition-all">
                <div className="bg-white rounded-t-xl shadow-xl p-6 max-h-[90vh] overflow-y-auto">
                  <div className="flex justify-between items-center mb-4">
                    <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                      Filters
                    </Dialog.Title>
                    <button
                      type="button"
                      className="text-gray-400 hover:text-gray-500"
                      onClick={() => setIsDialogOpen(false)}
                    >
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                  {dialogFilterData ? (
                    <SideBarSearch
                      filterSearchResult={dialogFilterData}
                      propertyType={true}
                    />
                  ) : (
                    <p>Loading filters...</p>
                  )}
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>

      {noMoreData && (
        <NoMoreDataComponent/>
      )}
    </>
  );
}




const NoMoreDataComponent = () => (
  <div className="pt-16">
    <div className="flex col-span-1 sm:col-span-2 xl:col-span-3 w-full max-w-7xl m-auto bg-gray-50">
      <PlaceholderComponent />
    </div>
    <div className="flex col-span-1 sm:col-span-2 xl:col-span-3 w-full max-w-7xl m-auto">
      <PlaceHolderContent />
    </div>
    <Footer />
  </div>
);